import React, { useEffect, useState, useContext } from "react";
import { Redirect, withRouter, Link } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

import AuthContext from "../../context/AuthContext";
import useObtenerUsuario from "../../utils/useObtenerUsuario";

import MPage from "../templates/mpage";
import FormInput from "../components/forminput";

const FormVotacionPrivada = (props) => {
  const { loggedIn } = useContext(AuthContext);
  const [usuario, errorUsuario] = useObtenerUsuario(loggedIn);

  const [municipio, guardarMunicipio] = useState(undefined);
  const [propuestas, guardarPropuestas] = useState(undefined);
  const [error, guardarError] = useState(false);
  const [dni, guardarDni] = useState(undefined);
  const [msjError, guardarMsjError] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  //Obtengo el municipio
  useEffect(() => {
    if (usuario !== undefined) {
      const obtenerMunicipio = () => {
        axios
          .get(`/api/municipios/${usuario.municipioId}`)
          .then((res) => {
            guardarMunicipio(res.data.municipio);
          })
          .catch((error) => guardarError(true));
      };
      obtenerMunicipio();
    }
    return () => {
      guardarMunicipio(undefined);
    };
  }, [usuario]);

  //Obtengo las propuestas
  useEffect(() => {
    if (municipio !== undefined) {
      const obtenerPropuestas = () => {
        axios
          .get(`/api/propuestas?municipioId=${municipio._id}&estado=aceptada`)
          .then((res) => {
            guardarPropuestas(res.data.propuestas);
          })
          .catch((error) => guardarError(true));
      };
      obtenerPropuestas();
    }
    return () => {
      guardarPropuestas(undefined);
    };
  }, [municipio]);

  const onFormSubmit = (data) => {
    //Guardo la propuesta
    data["municipioId"] = municipio._id;
    data["usuarioControl"] = usuario.usuario;

    data["propuestaTitulo"] = propuestas.filter(
      (propuesta) => propuesta._id === data["propuestaId"]
    )[0].titulo;

    axios
      .post(`/api/votos/auth/${municipio._id}`, data)
      .then(() => {
        //Redireccionar
        Swal.fire("¡Se generó en voto correctamente!", "", "success");
        props.history.push("/consola");
      })
      .catch((err) => {
        Swal.fire(
          err.response.data.errorMessage,
          "Por favor inténtelo de nuevo o pónganse en contacto con el Programa Raíz.",
          "error"
        );
      });
  };

  const actualizarDni = (event) => {
    guardarDni(event.target.value);
  };

  const actualizarPropuesta = (propuestaId) => {
    setValue("propuestaId", propuestaId, { shouldValidate: true });
    Swal.fire("¡Propuesta Seleccionada!", "", "success");
  };

  const consultarDni = () => {
    axios
      .get("/api/vecinos/" + municipio._id + "/" + dni)
      .then((res) => {
        const vecino = res.data.vecino;
        setValue("nombre", vecino.nombre, { shouldValidate: true });
        setValue("dir", vecino.dir, { shouldValidate: true });
        guardarMsjError(false);
      })
      .catch((error) => {
        setValue("nombre", "", { shouldValidate: true });
        setValue("dir", "", { shouldValidate: true });
        guardarMsjError(true);
      });
  };

  if (loggedIn === false) return <Redirect to="/login" />;
  if (errorUsuario === true || error === true) return <Redirect to="/" />;
  if (
    usuario === undefined ||
    municipio === undefined ||
    propuestas === undefined
  )
    return null;
  if (
    usuario.editarVotacion === false ||
    municipio.etapa !== "votacion" ||
    municipio.tipoVotacion === "publica"
  )
    return <Redirect to="/consola" />;

  return (
    <MPage municipio={municipio}>
      <div className="row">
        <div className="col-md-12">
          <h1 className="ppr-titulo centrado my-2">Votación</h1>
          <p>Formulario votación.</p>
          <small className=" text-muted">
            Los campos indicados con <b>*</b> son obligatorios.
          </small>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="from-group my-4">
              <label htmlFor="propuestaId">* Propuesta Elegida:</label>
              <select
                {...register("propuestaId", {
                  validate: (value) => value !== "0",
                })}
                type="text"
                className="form-control"
                id="propuestaId"
                name="propuestaId"
                defaultValue="0"
              >
                <option key="placeholder" value="0" disabled>
                  Selecciona una propuesta a votar.
                </option>
                {propuestas.map((propuesta) => (
                  <option key={propuesta._id} value={propuesta._id}>
                    {propuesta.titulo}
                  </option>
                ))}
              </select>
              {errors.propuestaId && (
                <small className="text-danger form-text">
                  Campo Obligatorio.
                </small>
              )}
            </div>

            <div className="row">
              {propuestas.map((propuesta) => (
                <div className="col-md-6 card-deck mx-auto" key={propuesta._id}>
                  <div className="card mb-3">
                    <div className="row">
                      <div className="col-md-4">
                        <img
                          className="thumbnail img-fluid"
                          src={`/api/public/${propuesta.img}`}
                          alt={propuesta.titulo}
                        />
                      </div>
                      <div className="col-md-8">
                        <div className="card-body">
                          {propuesta.eje && (
                            <span className="badge badge-primary tag">
                              {propuesta.eje}
                            </span>
                          )}
                          <h6 className="card-title centrado m-1">
                            {propuesta.titulo}
                          </h6>
                          <small className="card-text centrado m-1">
                            {propuesta.subtitulo}
                          </small>
                          <center>
                            <button
                              type="button"
                              onClick={() => actualizarPropuesta(propuesta._id)}
                              className="btn ppr-btn-azul font-weight-bold m-1 btn-xs"
                            >
                              Seleccionar
                            </button>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h4 className="ppr-titulo">Datos Personales</h4>
            <div className="from-group mb-3">
              <label htmlFor="dni">* DNI:</label>
              <button
                type="button"
                onClick={(e) => consultarDni(e.target.value)}
                className="btn ppr-btn-azul font-weight-bold m-2 btn-sm"
              >
                Consultar
              </button>
              {msjError && (
                <small className="text-danger form-text">
                  No se encuentra en el padrón.
                </small>
              )}
              <input
                {...register("dni", { required: true })}
                type="text"
                className="form-control"
                id="dni"
                placeholder="DNI"
                onChange={actualizarDni}
              ></input>
              {errors.dni && (
                <small className="text-danger form-text">
                  Campo Obligatorio.
                </small>
              )}
            </div>

            <FormInput
              register={register}
              error={errors.nombre}
              label={"* Nombre y Apellido:"}
              id={"nombre"}
              isRequired={true}
              placeholder="Nombre y apellido como figuran en el DNI."
            />

            <FormInput
              register={register}
              error={errors.fechaNac}
              label={"* Fecha de Nacimineto:"}
              id={"fechaNac"}
              isRequired={true}
              placeholder="Fecha de nacimineto que figura en el DNI."
              type="date"
            />

            <FormInput
              register={register}
              error={errors.dir}
              label={"* Domicilio:"}
              id={"dir"}
              isRequired={true}
              placeholder="Dirección que figura en el DNI."
              type="direccion"
            />

            <FormInput
              register={register}
              error={errors.email}
              label={"* Correo Electrónico:"}
              id={"email"}
              isRequired={true}
              placeholder="Dirección de correo electrónico."
              type="email"
            />

            <FormInput
              register={register}
              error={errors.tel}
              label={"* Teléfono:"}
              id={"tel"}
              isRequired={true}
              placeholder="Número de telefono de contacto."
              type="tel"
            />

            <center>
              <button
                type="submit"
                className="btn ppr-btn-verde font-weight-bold m-2 mr-5"
              >
                Guardar
              </button>
              <Link
                to={"/consola"}
                className="btn ppr-btn-verde font-weight-bold m-2"
              >
                Volver
              </Link>
            </center>
          </form>
        </div>
      </div>
    </MPage>
  );
};

export default withRouter(FormVotacionPrivada);
